import { PORTAL_TYPES } from "../../../app/constants/roles"

export const getSystemUserRoles = ({ auth }: any) => {
	return auth.userRoles.filter((x: any) => x.role_id.portal_type === PORTAL_TYPES.SYSTEM_PORTAL);
}

export const getTenantUserRoles = ({ auth }: any) => {
	return auth.userRoles.filter((x: any) => x.role_id.portal_type === PORTAL_TYPES.TENANT_PORTAL);
}

export const getBranchUserRoles = ({ auth }: any) => {
	return auth.userRoles.filter((x: any) => x.role_id.portal_type === PORTAL_TYPES.BRANCH_PORTAL);
}